// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PJjo","icon":"styles_icon__2yodK"};